class InstallationController {
  constructor ($window, $stateParams) {
    'ngInject'
    this.$window = $window
    this.success = $stateParams.success
  }
}

export default InstallationController



// WEBPACK FOOTER //
// ./src/app/pages/installation/installation.controller.js